import { render, staticRenderFns } from "./topicdl.vue?vue&type=template&id=458a2fdc&"
import script from "./topicdl.vue?vue&type=script&lang=js&"
export * from "./topicdl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports